import cn from 'classnames';
import { useState, type JSX } from 'react';

import styles from './answer.module.scss';
import { TAnswer } from '../../quiz.data';

type TAnswerProps = {
  className?: string;
  answer: TAnswer;
  count: number;
  onChoiseAnswer(answer: TAnswer): void;
};

export const Answer = ({
  answer,
  className,
  count,
  onChoiseAnswer,
}: TAnswerProps): JSX.Element => {
  const [isSelected, setIsSelected] = useState(false);
  const handleClick = (): void => {
    setIsSelected(true);
    onChoiseAnswer(answer);
  };

  return (
    <div
      onClick={handleClick}
      className={cn(styles.root, className, {
        [styles.isSelected]: isSelected,
      })}
    >
      <div className={styles.count}>{count}</div>
      <div className={styles.content}>{answer.text}</div>
    </div>
  );
};
